export default "__VITE_ASSET__CUuqBIPN__"